module.exports = __webpack_public_path__ + "static/0007-3f028e9d71414773aef57fe06b463d30.png";